// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

export const initialState = fromJS({
  contact: null,
  email: '',
  firstName: '',
  lastName: '',
  permissions: {},
  defaultUnitType: null,

  // this is used to track the setTimeout for logging the user out/renewing token etc
  sessionTimeout: null,
  // same as above but tracks the timeout for the notification which displays 10 mins before the user is force logged out.
  renewSessionMessageTimeout: null,

  // NOTE: "userDomain: 1" is hard coded as it will not be overridden from API's user data.
  // this is because option 1 is only USA but we want to easily allow
  // for internationalization in later phases
  userDomain: 1,
  userId: null,
  userName: '',
})
